import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from '@/components/ui/dialog';
import { Plus, Trash2, Truck } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';
import EmptyState from '@/components/common/EmptyState';

export default function SuppliersManager() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [location, setLocation] = useState('');
  const [phone, setPhone] = useState('');

  const load = async () => {
    const { data } = await api.get('/suppliers');
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!name || !location) return toast.error('Nama & lokasi wajib');
    try {
      await api.post('/suppliers', { name, location, phone });
      toast.success('Supplier ditambah');
      setName(''); setLocation(''); setPhone(''); setOpen(false);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Gagal simpan'); }
  };

  const remove = async (s) => {
    if (!window.confirm(`Hapus supplier ${s.name}?`)) return;
    try {
      await api.delete(`/suppliers/${s.id}`);
      toast.success('Supplier dihapus');
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Gagal hapus'); }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div className="text-sm text-muted-foreground">{items.length} supplier</div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-supplier-button"><Plus className="h-4 w-4 mr-2" />Tambah Supplier</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Tambah Supplier</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div className="space-y-1.5"><Label>Nama Supplier</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="supplier-name" /></div>
              <div className="space-y-1.5"><Label>Lokasi</Label><Input value={location} onChange={(e) => setLocation(e.target.value)} data-testid="supplier-location" /></div>
              <div className="space-y-1.5"><Label>Telepon (opsional)</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
            </div>
            <DialogFooter><Button onClick={save} data-testid="supplier-save-button">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      {items.length === 0 ? (
        <EmptyState icon={Truck} title="Belum ada supplier" description="Tambahkan supplier untuk memulai stock-in barang." />
      ) : (
        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Lokasi</TableHead><TableHead>Telepon</TableHead><TableHead /></TableRow></TableHeader>
              <TableBody>
                {items.map((s) => (
                  <TableRow key={s.id} data-testid={`supplier-row-${s.id}`}>
                    <TableCell className="font-medium">{s.name}</TableCell>
                    <TableCell>{s.location}</TableCell>
                    <TableCell className="font-mono text-xs">{s.phone || '-'}</TableCell>
                    <TableCell className="text-right">
                      <Button size="sm" variant="outline" className="text-rose-600" onClick={() => remove(s)}><Trash2 className="h-3.5 w-3.5" /></Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
